import React from 'react';
import { Layout } from '../components/Layout';

const PrivacyPolicyPage = () => {
  return (
    <Layout>
      <div className="py-12 md:py-20">
        <div className="max-w-[900px] mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-semibold text-black mb-4" data-testid="privacy-title">
            Privacy Policy
          </h1>
          <p className="text-base text-[#333333] mb-16">
            Last updated: February 22, 2026
          </p>

          <div className="space-y-12">
            <div>
              <p className="text-base md:text-lg leading-relaxed text-[#333333] mb-6">
                AI Atlas ("we", "our", or "us") respects your privacy. This page explains what information we collect and how we use it.
              </p>
            </div>

            <section>
              <h2 className="text-3xl md:text-4xl font-semibold text-black mb-4">
                1. Information We Collect
              </h2>
              <p className="text-base md:text-lg leading-relaxed text-[#333333] mb-4">
                We may collect:
              </p>
              <ul className="space-y-3 ml-6">
                <li className="text-base md:text-lg leading-relaxed text-[#333333]">
                  • Search queries you enter on the website
                </li>
                <li className="text-base md:text-lg leading-relaxed text-[#333333]">
                  • Basic usage data (such as pages visited, time spent, device type)
                </li>
                <li className="text-base md:text-lg leading-relaxed text-[#333333]">
                  • Technical information like browser type and IP address
                </li>
                <li className="text-base md:text-lg leading-relaxed text-[#333333]">
                  • Cookies used for site functionality and analytics
                </li>
              </ul>
              <div className="mt-6 space-y-2">
                <p className="text-base md:text-lg leading-relaxed text-black font-semibold">
                  We do not collect sensitive personal information.
                </p>
                <p className="text-base md:text-lg leading-relaxed text-black font-semibold">
                  We do not sell your data.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-3xl md:text-4xl font-semibold text-black mb-4">
                2. How We Use Information
              </h2>
              <p className="text-base md:text-lg leading-relaxed text-[#333333] mb-4">
                We use collected information to:
              </p>
              <ul className="space-y-3 ml-6">
                <li className="text-base md:text-lg leading-relaxed text-[#333333]">
                  • Improve search results and recommendations
                </li>
                <li className="text-base md:text-lg leading-relaxed text-[#333333]">
                  • Understand how users interact with the website
                </li>
                <li className="text-base md:text-lg leading-relaxed text-[#333333]">
                  • Improve clarity, usability, and performance
                </li>
                <li className="text-base md:text-lg leading-relaxed text-[#333333]">
                  • Maintain site security
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-3xl md:text-4xl font-semibold text-black mb-4">
                3. Third-Party Services
              </h2>
              <p className="text-base md:text-lg leading-relaxed text-[#333333] mb-4">
                We may use third-party services such as analytics tools to understand website traffic. These services may collect information according to their own privacy policies.
              </p>
              <p className="text-base md:text-lg leading-relaxed text-[#333333]">
                AI Atlas is not responsible for the privacy practices of third-party tools linked on this website.
              </p>
            </section>

            <section>
              <h2 className="text-3xl md:text-4xl font-semibold text-black mb-4">
                4. External Links
              </h2>
              <p className="text-base md:text-lg leading-relaxed text-[#333333] mb-3">
                AI Atlas contains links to third-party AI tools and websites.
              </p>
              <p className="text-base md:text-lg leading-relaxed text-[#333333]">
                We are not responsible for their content, privacy practices, or policies.
              </p>
            </section>

            <section>
              <h2 className="text-3xl md:text-4xl font-semibold text-black mb-4">
                5. Data Security
              </h2>
              <p className="text-base md:text-lg leading-relaxed text-[#333333]">
                We take reasonable steps to protect the information collected through this website. However, no method of online transmission or storage is completely secure.
              </p>
            </section>

            <section>
              <h2 className="text-3xl md:text-4xl font-semibold text-black mb-4">
                6. Your Choices
              </h2>
              <p className="text-base md:text-lg leading-relaxed text-[#333333] mb-4">
                You can:
              </p>
              <ul className="space-y-3 ml-6">
                <li className="text-base md:text-lg leading-relaxed text-[#333333]">
                  • Disable cookies in your browser settings
                </li>
                <li className="text-base md:text-lg leading-relaxed text-[#333333]">
                  • Stop using the website at any time
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-3xl md:text-4xl font-semibold text-black mb-4">
                7. Changes to This Policy
              </h2>
              <p className="text-base md:text-lg leading-relaxed text-[#333333]">
                We may update this Privacy Policy from time to time. Updates will be posted on this page with a revised "Last updated" date.
              </p>
            </section>

            <section>
              <h2 className="text-3xl md:text-4xl font-semibold text-black mb-4">
                8. Contact
              </h2>
              <p className="text-base md:text-lg leading-relaxed text-[#333333] mb-3">
                If you have questions about this Privacy Policy, you can contact us at:
              </p>
              <a 
                href="mailto:hello@youraiatlas.com" 
                className="text-base md:text-lg text-[#0044CC] hover:underline"
              >
                hello@youraiatlas.com
              </a>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPolicyPage;